export default "__VITE_ASSET__NibPHagz__"